module.exports = __webpack_public_path__ + "media/images/svg/logo-74ed15c05c90d13887bf35088d4a6206.svg";